// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICardHolderCardDto } from './ICardHolderCardDto';
import {
    ICardHolderCardDtoFromJSON,
    ICardHolderCardDtoFromJSONTyped,
    ICardHolderCardDtoToJSON,
    ICardHolderCardDtoToJSONTyped,
} from './ICardHolderCardDto';
import type { IExtendedCardDto } from './IExtendedCardDto';
import {
    IExtendedCardDtoFromJSON,
    IExtendedCardDtoFromJSONTyped,
    IExtendedCardDtoToJSON,
    IExtendedCardDtoToJSONTyped,
} from './IExtendedCardDto';

/**
 * 
 * @export
 * @interface ICardHolderWithDependentDto
 */
export interface ICardHolderWithDependentDto {
    /**
     * 
     * @type {number}
     * @memberof ICardHolderWithDependentDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICardHolderWithDependentDto
     */
    preferred_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardHolderWithDependentDto
     */
    middle_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardHolderWithDependentDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardHolderWithDependentDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardHolderWithDependentDto
     */
    suffix?: string;
    /**
     * 
     * @type {number}
     * @memberof ICardHolderWithDependentDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardHolderWithDependentDto
     */
    dependent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICardHolderWithDependentDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardHolderWithDependentDto
     */
    card_holder_type?: ICardHolderWithDependentDtoCardHolderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICardHolderWithDependentDto
     */
    card_holder_status?: ICardHolderWithDependentDtoCardHolderStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof ICardHolderWithDependentDto
     */
    date_of_birth?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICardHolderWithDependentDto
     */
    relationship?: ICardHolderWithDependentDtoRelationshipEnum;
    /**
     * 
     * @type {number}
     * @memberof ICardHolderWithDependentDto
     */
    person_id?: number;
    /**
     * 
     * @type {Array<ICardHolderCardDto>}
     * @memberof ICardHolderWithDependentDto
     */
    cards?: Array<ICardHolderCardDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ICardHolderWithDependentDto
     */
    deleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ICardHolderWithDependentDto
     */
    removed_for_employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: Array<IExtendedCardDto>; }}
     * @memberof ICardHolderWithDependentDto
     */
    grouped_cards?: { [key: string]: Array<IExtendedCardDto>; };
    /**
     * 
     * @type {Array<ICardHolderWithDependentDto>}
     * @memberof ICardHolderWithDependentDto
     */
    dependents?: Array<ICardHolderWithDependentDto>;
}

/**
* @export
* @enum {string}
*/
export enum ICardHolderWithDependentDtoCardHolderTypeEnum {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY'
}
/**
* @export
* @enum {string}
*/
export enum ICardHolderWithDependentDtoCardHolderStatusEnum {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED'
}
/**
* @export
* @enum {string}
*/
export enum ICardHolderWithDependentDtoRelationshipEnum {
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    OTHER = 'OTHER'
}


/**
 * Check if a given object implements the ICardHolderWithDependentDto interface.
 */
export function instanceOfICardHolderWithDependentDto(value: object): value is ICardHolderWithDependentDto {
    return true;
}

export function ICardHolderWithDependentDtoFromJSON(json: any): ICardHolderWithDependentDto {
    return ICardHolderWithDependentDtoFromJSONTyped(json, false);
}

export function ICardHolderWithDependentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardHolderWithDependentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'preferred_name': json['preferred_name'] == null ? undefined : json['preferred_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'dependent_id': json['dependent_id'] == null ? undefined : json['dependent_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'card_holder_type': json['card_holder_type'] == null ? undefined : json['card_holder_type'],
        'card_holder_status': json['card_holder_status'] == null ? undefined : json['card_holder_status'],
        'date_of_birth': json['date_of_birth'] == null ? undefined : (new Date(json['date_of_birth'])),
        'relationship': json['relationship'] == null ? undefined : json['relationship'],
        'person_id': json['person_id'] == null ? undefined : json['person_id'],
        'cards': json['cards'] == null ? undefined : ((json['cards'] as Array<any>).map(ICardHolderCardDtoFromJSON)),
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'removed_for_employee_id': json['removed_for_employee_id'] == null ? undefined : json['removed_for_employee_id'],
        'grouped_cards': json['grouped_cards'] == null ? undefined : json['grouped_cards'],
        'dependents': json['dependents'] == null ? undefined : ((json['dependents'] as Array<any>).map(ICardHolderWithDependentDtoFromJSON)),
    };
}

export function ICardHolderWithDependentDtoToJSON(json: any): ICardHolderWithDependentDto {
    return ICardHolderWithDependentDtoToJSONTyped(json, false);
}

export function ICardHolderWithDependentDtoToJSONTyped(value?: ICardHolderWithDependentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'preferred_name': value['preferred_name'],
        'middle_name': value['middle_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'employee_id': value['employee_id'],
        'dependent_id': value['dependent_id'],
        'organization_path': value['organization_path'],
        'card_holder_type': value['card_holder_type'],
        'card_holder_status': value['card_holder_status'],
        'date_of_birth': value['date_of_birth'] == null ? undefined : ((value['date_of_birth']).toISOString().substring(0,10)),
        'relationship': value['relationship'],
        'person_id': value['person_id'],
        'cards': value['cards'] == null ? undefined : ((value['cards'] as Array<any>).map(ICardHolderCardDtoToJSON)),
        'deleted': value['deleted'],
        'removed_for_employee_id': value['removed_for_employee_id'],
        'grouped_cards': value['grouped_cards'],
        'dependents': value['dependents'] == null ? undefined : ((value['dependents'] as Array<any>).map(ICardHolderWithDependentDtoToJSON)),
    };
}

